import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ProjectBusinessPartnerModel {
    projectId: number
    businessPartnerTypeId: number
    businessPartnerId: number
}

const AddBusinessPartnerPopup: React.FC<ProjectPopupProps> = ({ show, onHide, projectId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ProjectBusinessPartnerModel>({
        projectId: projectId,
        businessPartnerTypeId: 0,
        businessPartnerId: 0,
    });

    const businessPartnerTypes = useSelectListOptions('api/v1/selectlist/businessPartnerTypes?activeOnly=true', '-- Select business-partner type');
    const businessPartners = useSelectListOptions('api/v1/selectlist/businessPartners?activeOnly=true&businessPartnerTypeId=' + formData.businessPartnerTypeId, '-- Select business-partner');

    function submit() {
        if (formData) {
            DataService
                .create<ProjectBusinessPartnerModel>(`api/v1/ProjectBusinessPartners`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'businessPartnerTypeId', label: 'Business partner type', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'businessPartnerId', label: 'Business partner', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add business-partner'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('businessPartnerTypeId')} options={businessPartnerTypes} />
                <SelectListField {...getFieldProps('businessPartnerId')} options={businessPartners} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBusinessPartnerPopup;